import type { FC } from 'react';

import KpiMiniRow from '@/common-components/charts/KpiMiniRow';
import Pill from '@/common-components/Pill';
import type { CoinEconomy } from '@/types/stats.types';

interface CoinEconomyCardProps {
  economy: CoinEconomy;
}

const NUM = new Intl.NumberFormat('en-IN');

const CoinEconomyCard: FC<CoinEconomyCardProps> = ({ economy }) => (
  <section className="rounded-2xl border border-[var(--color-divider)] bg-white p-6 shadow-[var(--shadow-card)]">
    <header className="mb-2 flex items-center justify-between">
      <h2 className="text-[15px] font-extrabold text-[var(--color-ink)]">Coin Economy</h2>
      <Pill tone="brand">{NUM.format(economy.earned)} earned</Pill>
    </header>

    <KpiMiniRow title="🪙 Coins earned" value={NUM.format(economy.earned)} />
    <KpiMiniRow title="💸 Coins spent" value={NUM.format(economy.spent)} />
    <KpiMiniRow title="🔥 Coins burned" value={NUM.format(economy.burned)} />
    <KpiMiniRow
      title="📊 Net velocity"
      value={`${economy.netVelocity >= 0 ? '+' : ''}${NUM.format(economy.netVelocity)}`}
      valueColor={
        economy.netVelocity >= 0 ? 'var(--color-success-ink)' : 'var(--color-danger-ink)'
      }
    />

    <div className="mt-3 h-1.5 overflow-hidden rounded-[3px] bg-[var(--color-surface-muted-2)]">
      <div
        className="h-full rounded-[3px] bg-[var(--color-brand-500)]"
        style={{ width: `${Math.min(100, economy.redemptionPct)}%` }}
      />
    </div>
    <p className="mt-1.5 text-[11px] text-[var(--color-ink-muted)]">
      {economy.earned === 0
        ? 'No coins issued yet.'
        : `${economy.redemptionPct}% of issued coins have been spent.`}
    </p>
  </section>
);

export default CoinEconomyCard;
